<template>
  <div v-show="visible" class="task-rewards-float-dialog" :style="{ zIndex }" @touchmove.prevent>
    <div class="task-rewards-float-dialog__backdrop" @click="onBackdropClick"></div>
    <div class="task-rewards-float-dialog__main">
      <div class="task-rewards-float-dialog__column">
        <div v-if="$slots.float" class="task-rewards-float-dialog__float-wrap">
          <slot name="float"></slot>
        </div>
        <transition name="task-rewards-float-dialog-fade">
          <div
            v-if="showAnimation"
            class="task-rewards-float-dialog__panel"
            role="dialog"
            aria-modal="true"
            @click.stop
          >
            <button
              v-if="showClose"
              type="button"
              class="task-rewards-float-dialog__close"
              :aria-label="closeAriaLabel"
              :style="{ backgroundImage: `url(${dialogCloseIcon})` }"
              @click="handleClose"
            />
            <div class="task-rewards-float-dialog__header">
              <div class="task-rewards-float-dialog__title">
                <AutoFitMutilComp
                  multi-line
                  height="1.0667rem"
                  text-align="center"
                  :max-font-size="0.5067"
                  :text="title"
                />
              </div>
            </div>
            <div class="task-rewards-float-dialog__body">
              <slot></slot>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { AutoFitMutilComp } from 'components'
import dialogCloseIcon from '../../../../../packages/components/src/componentsUI/dialog/icon_close.png'

export default {
  name: 'TaskRewardsFloatDialog',
  components: { AutoFitMutilComp },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    closeOnClickOverlay: { type: Boolean, default: true },
    showClose: { type: Boolean, default: true },
    zIndex: { type: Number, default: 1000 },
    closeAriaLabel: { type: String, default: 'Close' },
  },
  data() {
    return {
      dialogCloseIcon,
      showAnimation: false,
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.showAnimation = true
          })
        } else {
          this.showAnimation = false
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    onBackdropClick() {
      if (this.closeOnClickOverlay) {
        this.handleClose()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.task-rewards-float-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.task-rewards-float-dialog__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.task-rewards-float-dialog__main {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.task-rewards-float-dialog__column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 100%;
  pointer-events: none;
}

.task-rewards-float-dialog__float-wrap {
  flex-shrink: 0;
  transform: scale(3);
  margin-bottom: 20px;
  pointer-events: none;
}

.task-rewards-float-dialog__panel {
  flex-shrink: 0;
  pointer-events: auto;
  position: relative;
  z-index: 2;
  background: #ffffff;
  border-radius: 0.32rem;
  width: 9.2rem;
  max-width: 98vw;
  overflow: visible;
  box-shadow: 0 0.5333rem 1.0667rem rgba(0, 0, 0, 0.1);
  padding-bottom: 16px;
}

.task-rewards-float-dialog__close {
  position: absolute;
  width: 0.64rem;
  height: 0.64rem;
  top: 0.3733rem;
  right: 0.3733rem;
  padding: 0;
  border: none;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  background-color: transparent;
  z-index: 3;
}

.task-rewards-float-dialog__header {
  min-height: 1.3867rem;
  padding: 0 1.0133rem;
  font-size: 0.5067rem;
  font-weight: 700;
  line-height: 1.1;
  white-space: normal;
  font-family: 'roboto-bold';
  font-style: Bold;
  font-weight: 700;
}

.task-rewards-float-dialog__title {
  min-height: 1.3867rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.task-rewards-float-dialog__body {
  padding: 0 0.32rem;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
  color: #666;
  line-height: 1.6;
}

.task-rewards-float-dialog-fade-enter-active,
.task-rewards-float-dialog-fade-leave-active {
  transition: all 0.2s ease-out;
}

.task-rewards-float-dialog-fade-enter,
.task-rewards-float-dialog-fade-leave-to,
.task-rewards-float-dialog-fade-leave-active {
  opacity: 0;
}
</style>

<style lang="less">
.task-rewards-float-dialog__body::-webkit-scrollbar {
  -webkit-appearance: none;
  display: none;
  width: 0 !important;
  height: 0 !important;
  background: transparent;
}

.task-rewards-float-dialog__body::-webkit-scrollbar-thumb,
.task-rewards-float-dialog__body::-webkit-scrollbar-track {
  display: none;
  background: transparent;
}
</style>
